const category = 'AppSpecificAssociation';

const cards = [
    {
        name: "Issuer Country",
        id: "issuerCountry",
        fields: [
            [
                {
                    id: "IssuerCountry",
                    layout: [
                        [
                            {
                                id: "ISO3A",
                            },
                        ],
                    ],
                },
            ],
        ],
    },
    {
        name: "Ethoca",
        id: "ethoca",
        fields: [
            [
                {
                    id: "EthocaEnabled",
                },
            ],
            [
                {
                    id: "ArePendingTransactionEthocaAlertsEnabled",
                },
            ],
        ],
    },
    {
        name: "Verifi",
        id: "verifi",
        fields: [
            [
                {
                    id: "VerifiEnabled",
                },
            ],
        ],
    },
    {
        name: "Mastercard",
        id: "mastercard",
        fields: [
            [
                {
                    id: "UseCardholderLetterInsteadOfDisputeResolutionForm",
                },
            ],
            [
                {
                    id: "IsMCStandInFileEnabled",
                },
            ],
            [
                {
                    id: "IsResolutionFormFIRepresentativeFallThroughEnabled",
                },
            ],
            [
                {
                    id: "MCFallThroughBehaviorLabel",
                },
            ],
            [
                {
                    id: "MCResolutionFormSignaturePreference",
                },
            ],
            [
                {
                    id: "MCResolutionFormFIRepresentativeValueReference",
                },
            ],
            [
                {
                    id: "MCStaticFIDisputeResolutionFormFallthroughValue",
                },
            ],
            [
                {
                    id: "MCPropertyRefPageFIDisputeResolutionFormFallthrough",
                },
            ],
            [
                {
                    id: "MCPropertyRefFIDisputeResolutionFormFallthrough",
                },
            ],
            [
                {
                    id: "IsMessageTextOverrideEnabled",
                },
            ],
        ],
    },
    {
        name: "Visa",
        id: "visa",
        fields: [
            [
                {
                    id: "IsVisaDPS",
                },
            ],
            [
                {
                    id: "VisaStopPaymentDurationInMonths",
                },
            ],
            [
                {
                    id: "IssuesVisaCommericalCardVirtualAccount",
                },
            ],
            [
                {
                    id: "VisaEnableReverseFraudReporting",
                },
            ],
        ],
    },
    {
        name: "Recovery Currency",
        id: "recoveryCurrency",
        fields: [
            [
                {
                    type: "content",
                    content: `
              <p>By default, recovery will be performed in the customer's posted currency.  On an association by association basis, you can configure other currencies to be used.  Local (merchant currency), Posted, and Settlement currencies may be used.</p>
            `,
                },
            ],
            [
                {
                    id: "AmexCurrencyType",
                },
            ],
            [
                {
                    id: "VisaCurrencyType",
                },
            ],
            [
                {
                    id: "DefaultCurrencyType",
                },
            ],
            [
                {
                    id: "MasterCardCurrencyType",
                },
            ],
        ],
    },
];

export { cards, category };